var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2105 0.789489C67.1579 -0.263163 65.4512 -0.263163 64.3987 0.789489L0.789459 64.3988C-0.263194 65.4514 -0.263194 67.1579 0.789459 68.2105C1.31572 68.7369 2.00558 68.9999 2.69531 68.9999C3.38504 68.9999 4.0749 68.7367 4.6013 68.2105L68.2105 4.60119C69.2632 3.54868 69.2632 1.84214 68.2105 0.789489Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.8231e0126dbf10eff51eabeaec9081cc.svg";
export { ForwardRef as ReactComponent };